import React from 'react';
import { Box } from '@skin-seoul/design-system';

type ProductCardContentProps = {
  children: React.ReactNode;
};

export const VerticalProductCardContent = ({ children }: ProductCardContentProps) => {
  return (
    <Box display="flex" flexDirection="column" gap={2} width="100%" minWidth={0} borderRadius="0 0 8px 8px">
      <>{children}</>
    </Box>
  );
};
